import React, { useCallback } from 'react';
import { ItemButton, MenuItemContainer, MenuItemText } from '../styledComponents';

const MenuItem = ({ args: { navigationTouchHandler, dynamicGameRoomsEnabled, activeGameRoom }, item, itemsLength }) => {
  const isActive = dynamicGameRoomsEnabled ? item?.room_id === activeGameRoom?.room_id : item?.active || false;
  const handlePress = useCallback(() => navigationTouchHandler(item), [navigationTouchHandler, item]);

  return (
    <MenuItemContainer isDisabled={item?.disabled} onClick={handlePress}>
      <ItemButton isActive={isActive} itemsLength={itemsLength} />
      <MenuItemText data-text={item.roomName}>
        <span>{item.roomName}</span>
      </MenuItemText>
    </MenuItemContainer>
  );
};

export default MenuItem;

